<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.addAdmin") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="validateFormInputs">
          <div class="row">
            <ValidationProvider
              name="الصورة"
              rules="required"
              v-slot="{ errors }"
              class="col-12"
            >
              <base-image-upload-input
                col="12"
                identifier="admin_image"
                :placeholder="$t('PLACEHOLDERS.personalImage')"
                @selectImage="selectImage"
                :errors="errors[0]"
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.name')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="text"
                :errors="errors[0] || nameServerError"
                @input="nameServerError = null"
                :placeholder="$t('PLACEHOLDERS.name')"
                v-model.trim="data.name"
                required
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.email')"
              rules="required|email"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.email')"
                v-model.trim="data.email"
                @input="emailServerError = null"
                :errors="errors[0] || emailServerError"
                required
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.phone')"
              class="col-lg-6"
            >
              <base-phone-input
                col="12"
                required
                v-model="data.phone"
                @dialCode="dialCode"
                @input="mobileServerError = null"
                ref="phoneInput"
                @hasError="hasError"
                :errors="mobileServerError"
                :placeholder="$t('PLACEHOLDERS.phone')"
                :defaultCountry="data.iso_code"
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.role')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-select-input
                col="12"
                :optionsList="roles ?? []"
                :placeholder="$t('PLACEHOLDERS.role')"
                v-model="data.role"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>
            <input
              type="text"
              name="fake-user"
              style="display: none"
              autocomplete="username"
            />
            <input
              type="password"
              name="fake-pass"
              style="display: none"
              autocomplete="new-password"
            />

            <ValidationProvider
              :name="$t('PLACEHOLDERS.password')"
              rules="required|custom_password"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="password"
                :placeholder="$t('PLACEHOLDERS.password')"
                v-model.trim="data.password"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.confirmPassword')"
              :rules="{
                required: true,
                password_match: { target: data.password },
              }"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="password"
                :placeholder="$t('PLACEHOLDERS.confirmPassword')"
                v-model.trim="data.passwordConfirmation"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <div class="input_wrapper switch_wrapper my-5 col-12">
              <v-switch
                color="green"
                :label="
                  data.active
                    ? $t('PLACEHOLDERS.active')
                    : $t('PLACEHOLDERS.notActive')
                "
                v-model="data.active"
                hide-details
              ></v-switch>
            </div>

            <div class="btn_wrapper col-12 text-end">
              <base-button
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.save')"
                :isLoading="isWaitingRequest"
                :disabled="invalid || isWaitingRequest"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "CreateAdmin",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        email: null,
        phone: null,
        hasError: null,
        role: null,
        password: null,
        passwordConfirmation: null,
        whatsApp: null,
        areas: [],
        roles: [],
        active: true,
        code: null,
        dial_code: null,
        validPhone: false,
      },
      emailServerError: null,
      mobileServerError: null,
      nameServerError: null,
      allAreas: [],
    };
  },

  methods: {
    hasError(data) {
      this.data.hasError = data;
    },
    dialCode(data) {
      this.data.dial_code = data.dialCode;
    },

    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    focusInput() {
      this.$refs.phoneInput?.focus();
    },
    validateFormInputs() {
      this.focusInput();
      this.isWaitingRequest = true;

      if (!this.data.name) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name"));
        return;
      } else if (!this.data.email) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.email"));
        return;
      } else if (!this.data.phone) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.mobileNumber"));
        return;
      } else if (!this.data.role) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.role"));
        return;
      } else if (!this.data.password) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.password"));
        return;
      } else if (this.data.password.length < 6) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.passwordLength"));
        return;
      } else if (!this.data.passwordConfirmation) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.password"));
        return;
      } else if (this.data.passwordConfirmation.length < 6) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.passwordLength"));
        return;
      } else if (this.data.password != this.data.passwordConfirmation) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.notEqualPasswords"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    async getRoles() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "roles?page=0&limit=0&status=1&ignorePermissionCheck=1",
        });
        this.roles = res.data.data;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    setServerError(field, error) {
      this[`${field}ServerError`] =
        error?.response?.data?.errors?.[field]?.[0] || null;
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.role) {
        REQUEST_DATA.append("role", this.data.role?.id);
      }
      REQUEST_DATA.append("name", this.data.name);
      if (this.data.image.file) {
        REQUEST_DATA.append("avatar", this.data.image.file);
      }
      REQUEST_DATA.append("alpha2", this.data.dial_code);
      REQUEST_DATA.append("email", this.data.email);
      REQUEST_DATA.append("mobile", this.data.phone);
      REQUEST_DATA.append("password", this.data.password);
      REQUEST_DATA.append(
        "password_confirmation",
        this.data.passwordConfirmation
      );
      REQUEST_DATA.append("is_active", +this.data.active);

      try {
        await this.$axios({
          method: "POST",
          url: `admins`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/admins/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.setServerError("email", error);
        this.setServerError("mobile", error);
        this.setServerError("name", error);
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    // Start:: Fire Methods
    await this.getRoles();
    // End:: Fire Methods
    this.$nextTick(() => {
      this.data.phone = "";
    });
  },
};
</script>
